import { t } from 'i18next';
import { call, put, takeLatest } from 'redux-saga/effects';
import { getLocation } from './data';
import { errorReceiveLocation, failedReceiveLocation, receiveLocation } from './slice';
export function* requestLocation(action) {
    try {
        const { consumerAPI, slug: locationSlug } = action.payload;
        const response = yield call(getLocation, locationSlug, consumerAPI);
        if (!consumerAPI) {
            const { data, error } = response;
            if (error) {
                yield put(errorReceiveLocation());
            }
            else if (data) {
                yield put(receiveLocation(data));
            }
            else {
                throw new Error(t('NO_DATA_AVAILABLE', {
                    ns: 'Common'
                }));
            }
        }
        else {
            if (response && response.status !== 200) {
                yield put(errorReceiveLocation());
            }
            else if (response && response.status === 200) {
                yield put(receiveLocation(response.data));
            }
            else {
                throw new Error(t('NO_DATA_AVAILABLE', {
                    ns: 'Common'
                }));
            }
        }
    }
    catch (e) {
        yield put(failedReceiveLocation());
    }
}
export function* watchRequestLocation() {
    yield takeLatest('location/requestLocation', requestLocation);
}
